import type { ReactNode } from 'react'
import { AuthBrandMark, cn } from '@yeshuman/sdk'

import { yeshumanAnn, yeshumanUiSans } from './typography'

export function WorkingSessionShell({
  children,
  stance,
}: {
  children: ReactNode
  stance?: string
}) {
  return (
    <div
      className={cn(
        'yeshuman-marketing-shell yeshuman-workbench yeshuman-loaded min-h-full',
        'bg-[var(--marketing-bg)] text-[var(--marketing-text)] antialiased',
        'selection:bg-[var(--marketing-gold)] selection:text-[var(--marketing-bg)]',
      )}
    >
      <header className="flex items-center justify-between px-6 py-4 md:px-10">
        <AuthBrandMark markKey="yeshumanWordmark" size="sm" className="[&_svg]:size-10 [&_svg]:shrink-0" />
        <div className="flex items-baseline gap-3">
          <p className={cn(yeshumanAnn, 'text-[var(--yeshuman-ink-subtle,var(--marketing-muted))]')}>
            Working session
          </p>
          {stance ? (
            <p
              className={cn(
                yeshumanUiSans,
                'text-sm font-medium capitalize tracking-wide',
                'text-[var(--marketing-gold)]',
              )}
            >
              {stance}
            </p>
          ) : null}
        </div>
      </header>
      <main className="px-6 pb-8 md:px-10">{children}</main>
    </div>
  )
}
